export default {
  date: '',
  operator: '',
  description: '',
};
